import { Routes } from '@angular/router';
import { DefaultLayoutComponent } from './layout';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },
  {
    path: '',
    component: DefaultLayoutComponent,
    data: {
      title: 'Home'
    },
    children: [
      /*{
        path: 'dashboard',
        loadChildren: () => import('./views/dashboard/routes').then((m) => m.routes)
      },
      {
        path: 'theme',
        loadChildren: () => import('./views/theme/routes').then((m) => m.routes)
      },
      {
        path: 'base',
        loadChildren: () => import('./views/base/routes').then((m) => m.routes)
      },
      {
        path: 'buttons',
        loadChildren: () => import('./views/buttons/routes').then((m) => m.routes)
      },
      {
        path: 'forms',
        loadChildren: () => import('./views/forms/routes').then((m) => m.routes)
      },
      {
        path: 'icons',
        loadChildren: () => import('./views/icons/routes').then((m) => m.routes)
      },
      {
        path: 'notifications',
        loadChildren: () => import('./views/notifications/routes').then((m) => m.routes)
      },
      {
        path: 'widgets',
        loadChildren: () => import('./views/widgets/routes').then((m) => m.routes)
      },
      {
        path: 'charts',
        loadChildren: () => import('./views/charts/routes').then((m) => m.routes)
      },
      {
        path: 'pages',
        loadChildren: () => import('./views/pages/routes').then((m) => m.routes)
      },*/
      //Speedkdo routes
      {
        path: 'send-gift',
        loadChildren: () => import('./views/send-gift/routes').then((m) => m.routes)
      },
      {
        path: 'waiting-gift',
        loadChildren: () => import('./views/waiting-gift/routes').then((m) => m.routes)
      },
      {
        path: 'account-transaction',
        loadChildren: () => import('./views/account/routes').then((m) => m.routes)
      },
      {
        path: 'credit-order',
        loadChildren: () => import('./views/credit-order/routes').then((m) => m.routes)
      },
      {
        path: 'account-management',
        loadChildren: () => import('./views/account-management/routes').then((m) => m.routes)
      },
      {
        path: 'recipients',
        loadChildren: () => import('./views/recipients/routes').then((m) => m.routes)
      },
      {
        path: 'distribution-report',
        loadChildren: () => import('./views/distribution-report/routes').then((m) => m.routes)
      },
      {
        path: 'partner-brands',
        loadChildren: () => import('./views/partner-brands/routes').then((m) => m.routes)
      }
    ]
  },
  /*{
    path: '404',
    loadComponent: () => import('./views/pages/page404/page404.component').then(m => m.Page404Component),
    data: {
      title: 'Page 404'
    }
  },
  {
    path: '500',
    loadComponent: () => import('./views/pages/page500/page500.component').then(m => m.Page500Component),
    data: {
      title: 'Page 500'
    }
  },*/
  {
    path: 'login',
    loadComponent: () => import('./views/pages/login/login.component').then(m => m.LoginComponent),
    data: {
      title: 'Login Page'
    }
  }
  /*,
  {
    path: 'register',
    loadComponent: () => import('./views/pages/register/register.component').then(m => m.RegisterComponent),
    data: {
      title: 'Register Page'
    }
  }*/,
  { path: '**', redirectTo: 'send-gift' }
];
